import React from 'react';
import { Search } from 'lucide-react';
import { DATE_PRESETS } from './paymentUtils';

export const PaymentFiltersBar = ({ filters, onChange }) => {
  const set = (patch) => onChange({ ...filters, ...patch, page: 1 });
  return (
    <div className="flex flex-col lg:flex-row lg:items-end gap-3" data-testid="payment-filters">
      <div className="flex flex-wrap items-end gap-2">
        <label className="text-xs text-slate-500 flex flex-col gap-1">
          From
          <input
            type="date"
            data-testid="payment-filter-from"
            value={filters.from}
            onChange={(e) => set({ from: e.target.value, preset: '' })}
            className="border rounded-md px-2 py-1.5 text-sm text-slate-800"
          />
        </label>
        <label className="text-xs text-slate-500 flex flex-col gap-1">
          To
          <input
            type="date"
            data-testid="payment-filter-to"
            value={filters.to}
            onChange={(e) => set({ to: e.target.value, preset: '' })}
            className="border rounded-md px-2 py-1.5 text-sm text-slate-800"
          />
        </label>
        <div className="flex flex-wrap gap-1">
          {DATE_PRESETS.map((p) => (
            <button
              key={p.key}
              type="button"
              data-testid={`payment-preset-${p.key}`}
              onClick={() => set({ ...p.range(), preset: p.key })}
              className={`px-2.5 py-1.5 text-xs rounded-md border ${
                filters.preset === p.key ? 'bg-slate-900 text-white border-slate-900' : 'bg-white text-slate-600 hover:bg-slate-50'
              }`}
            >
              {p.label}
            </button>
          ))}
        </div>
      </div>
      <div className="relative lg:ml-auto lg:w-80">
        <Search className="w-4 h-4 absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400" />
        <input
          type="search"
          data-testid="payment-search-input"
          value={filters.search}
          onChange={(e) => set({ search: e.target.value })}
          placeholder="Vendor, memo, invoice #, amount, QBO #"
          className="w-full border rounded-md pl-8 pr-2 py-1.5 text-sm"
        />
      </div>
    </div>
  );
};
